
import { mapGetters } from "vuex";
import TableApp from "@/components/Table/Table2";
import swal from "sweetalert";
import { SistemaMixin } from "@/modules/Application";
import flatPickr from "flatpickr";
import "flatpickr/dist/flatpickr.css";
import Whatsapp from "vue-material-design-icons/Whatsapp.vue";
import PdfIcon from "vue-material-design-icons/FilePdfBox.vue";
import PencilIcon from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Link from "vue-material-design-icons/LinkPlus.vue";

import "flatpickr/dist/themes/material_blue.css";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";
import FilterFields from "@/components/FilterFields";
import SendToWppModal from "@/components/SendToWppModal";
import Menu from "vue-material-design-icons/Menu";
import { actionsStore } from "@/components/Table/actionsStore";

export default {
  name: "pedidos",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    PdfIcon,
    PencilIcon,
    Link,
    Whatsapp,
    TrashCanIcon,
    FilterFields,
    SendToWppModal,
    Menu,
  },
  data() {
    return {
      actionsStore,
      components: {
        flatPickr,
      },
      ordemStatus: null,
      statusToUpdate: null,
      wppOpenModal: false,
      dataToWhatsapp: null,
      fields: [
        {
          label: "Número",
          field: "numero",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Fornecedor",
          field: "fornecedor",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "Data da Solicitação",
          field: "data_solicitacao",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Data de Criação",
          field: "created_at",
          sortable: false,
          slot: true,
          type: "date",
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd-MM-yyyy",
        },
        {
          label: "Valor",
          field: "valorTotal",
          sortable: false,
          slot: true,
          type: "text",
        },
        {
          label: "Status",
          field: "status",
          sortable: true,
          slot: true,
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
        },
      ],
      gerar_financeiro: true,
      movimentar_estoque: true,
      permitido_faturar: false,
      data_faturamento: null,
      faturamentoData: null,
      loadingFaturamento: false,
      parcelaFields: [
        { key: "parcela", label: "Parcela" },
        { key: "value", label: "Valor" },
        { key: "date", label: "Vencimento" },
      ],
    };
  },
  async created() {
    try {
      const { data } = await this.$http.post("/ordemcompra/status");
      this.ordemStatus = data;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async duplicar() {
      const { id_ordem_compra } = this.actionsStore?.selectedRows[0];

      this.addLoadingToButton("doubleOrdem");

      try {
        await this.$http.post("/ordemcompra/duplicar", {
          id_ordem_compra,
        });
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.$toast.success("Ordem duplicada com sucesso!");
        this.$refs.ordemList.refresh();
        this.$bvModal.hide("duplicarOrdem");
      } catch (error) {
        console.log(error);
      }
      this.removeLoadingToButton("doubleOrcamento");
    },
    doCopy(data) {
      swal({
        title: "Deseja enviar o link para o cliente?",
        text: "Ao confirmar será copiado para a area de transferencia o link",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        swal.close();
        swal.stopLoading();
        this.$copyText(data.link);
        this.$toast.success("Link copiado com sucesso!");
      });
    },
    salvarStatus() {
      this.$bvModal.hide("atualizarStatus");
      swal({
        title: "Deseja atualizar o(s) status?",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http.post("/ordemcompra/update-status", {
          ordens: actionsStore.selectedRows.map(({ id_ordem_compra }) => ({
            id_ordem_compra,
          })),
          status: this.statusToUpdate,
        });
        this.statusToUpdate = null;
        swal.close();
        swal.stopLoading();
        this.$refs.ordemList.refresh();
      });
    },
    imprimirOrdem(data) {
      swal({
        title: "Deseja imprimir a ordem?",
        text: "Aguarde, pois será gerado o PDF automaticamente!",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }
        await this.$http
          .post("/ordemcompra/print", {
            id_ordem_compra: data.id_ordem_compra,
          })
          .then(({ data }) => {
            if (data.url_ordem_compra) {
              window.open(data.url_ordem_compra, "_blank");
            }
            swal.stopLoading();
            swal.close();
            this.$toast.success("Ordem impressa com sucesso!");
          })
          .catch(() => {
            swal.stopLoading();
            swal.close();
          });
      });
    },
    async shareToWhatsapp(data) {
      this.dataToWhatsapp = data;
      this.wppOpenModal = true;
    },

    async editarOrdem(data) {
      swal({
        title: "Deseja editar a Ordem?",
        text: "Você ira ser direcionado para a pagina de edição aguarde...",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        await this.$http
          .post("/ordemcompra/find", {
            id_ordem_compra: data.id_ordem_compra,
          })
          .then((response) => {
            swal.stopLoading();
            swal.close();
            this.$toast.info("Você será redirecionado agora");
            this.$router.push({
              name: "ordemCompraNova",
              params: {
                ordemData: {
                  ...response.data,
                  ordemId: response.data.id_ordem_compra,
                },
              },
            });
          })
          .catch(() => {
            swal.stopLoading();
            this.$toast.error("Erro ao solicitar o endpoint do Pedido");
            swal.close();
          });
      });
    },

    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a ordem de compra?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/ordemcompra/delete", {
              id_ordem_compra: data.id_ordem_compra,
            });
            this.$refs.ordemList.refresh();
            this.$toast.success("Ordem excluída!");
          }
        });
    },
    formataPagamento(pagamento) {
      const pagamentos = JSON.parse(pagamento);
      var pagamentoFormatado = "";

      pagamentos.forEach((pag) => {
        if (pag.value == 0) {
          pagamentoFormatado = "Pedido sem valores para realizar faturamento.";
          this.permitido_faturar = true;
          return;
        }

        if (pag.value != 0 && pag.paymentMode.description) {
          this.permitido_faturar = false;
          pagamentoFormatado +=
            pag.paymentMode.description +
            ": R$ " +
            this.numberToReal(pag.value, 2);
        }
      });
      return pagamentoFormatado;
    },
    isFinanceiroBloqueado(row) {
      if (!row) return true;
      if (row.status === 3) return true;
      if (row.financeiro_gerado) return true;
      return false;
    },
    async abrirModalFinanceiro() {
      const selectedRow = this.actionsStore?.selectedRows[0];
      if (!selectedRow) {
        this.faturamentoData = null;
        return;
      }

      this.loadingFaturamento = true;
      this.faturamentoData = null;

      try {
        const { data } = await this.$http.post("/ordemcompra/faturamento", {
          id_ordem_compra: selectedRow.id_ordem_compra,
        });

        if (data.status && data.data) {
          this.faturamentoData = data.data;
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Erro ao carregar o faturamento da ordem de compra.");
      } finally {
        this.loadingFaturamento = false;
      }
    },
    recalcularValorTotal() {
      if (!this.faturamentoData || !this.faturamentoData.pagamentos) return;

      let total = 0;
      this.faturamentoData.pagamentos.forEach((pagamento) => {
        if (pagamento.range && Array.isArray(pagamento.range)) {
          pagamento.range.forEach((parcela) => {
            total += parseFloat(parcela.value) || 0;
          });
        }
      });

      this.faturamentoData.valorTotal = total;
    },
    async confirmarGerarFinanceiro() {
      const selectedRow = this.actionsStore?.selectedRows[0];
      if (!selectedRow || !this.faturamentoData) return;

      this.addLoadingToButton("btnGerarFinanceiro");

      try {
        await this.$http.post("/ordemcompra/gerar-financeiro", {
          id_ordem_compra: selectedRow.id_ordem_compra,
          pagamentos: this.faturamentoData.pagamentos,
          valorTotal: this.faturamentoData.valorTotal,
        });

        this.$toast.success("Financeiro gerado com sucesso!");
        this.$bvModal.hide("gerarFinanceiroOrdem");
        this.actionsStore.updateTable = !this.actionsStore.updateTable;
        this.actionsStore.selectedRows = [];
        this.$refs.ordemList.refresh();
      } catch (error) {
        console.log(error);
      }

      this.removeLoadingToButton("btnGerarFinanceiro");
    },
  },

  dateRangeFilter(data, filterString) {
    let dateRange = filterString.split("to");
    let startDate = Date.parse(dateRange[0]);
    let endDate = Date.parse(dateRange[1]);
    return (data =
      Date.parse(data) >= startDate && Date.parse(data) <= endDate);
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    let inputs = ['input[placeholder="Data"]'];
    inputs.forEach(function (input) {
      flatPickr(input, {
        dateFormat: "Y-m-d",
        allowInput: true,
        locale: Portuguese,
      });
    });
  },
};
